import { BookOpenCheckIcon, FileTextIcon, FolderOpenIcon, LightbulbIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Environmental Management Classroom Activities & Challenges',
    description:
      '150 ready-to-use activity ideas covering fundamentals, ecosystems, pollution, assessment, waste, organizational systems, climate challenges, sustainable development, and integrated environmental scenarios. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: '100 Environmental Problems & Decision-Making Scenarios',
    description:
      '100 environmental scenarios designed to challenge students to identify problems, analyze causes and consequences, recognize stakeholders, establish priorities, compare possible responses, make decisions, and justify their choices.',
    benefit:
      'Students develop critical thinking and environmental decision-making skills through authentic problem-solving.',
    value: 'USD 14',
    icon: ListChecksIcon,
  },
  {
    number: '03',
    title: '100 Environmental Case Studies & Real-World Scenarios',
    description:
      'A collection of 100 developed environmental cases involving communities, ecosystems, organizations, industries, pollution, resources, climate, sustainability, and integrated professional situations.',
    benefit:
      'Students analyze causes, consequences, stakeholders, management responses, and trade-offs through evidence-based reasoning.',
    value: 'USD 14',
    icon: FileTextIcon,
  },
  {
    number: '04',
    title: '50 Environmental Management Classroom Projects',
    description:
      '50 structured classroom projects that encourage students to investigate environmental issues, analyze problems, develop solutions, make recommendations, and communicate their conclusions through practical classroom work. Each includes objectives, procedures, expected outcomes, and assessment criteria.',
    benefit: 'Your students finish the year with real environmental management projects.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
  {
    number: '05',
    title: "Environmental Management Teacher's Concept & Terminology Guide",
    description:
      'Comprehensive reference handbook covering essential Environmental Management concepts and terminology. Designed to help teachers and students quickly review vocabulary related to ecology, pollution, assessment, waste, systems, climate, sustainability, and professional practice.',
    benefit: 'Project it in class and your students instantly understand complex environmental concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
    wide: true,
  },
];
